import React from 'react';
import { PenTool, Sparkles, MessageCircle, Settings } from 'lucide-react';
import { KawaiiButton } from '@components/button';
import type { Member } from 'src/gql/graphql';

interface MemberCardProps {
  member: Member;
  onChat: (id: string) => void;
  onSettings?: (id: string) => void;
}

const MemberCard: React.FC<MemberCardProps> = ({ member, onChat, onSettings = () => {} }) => (
  <div className="p-4 rounded-lg border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900">
    <div className="flex items-center gap-4 mb-4">
      <div className="relative">
        <div className="absolute -inset-0.5 bg-linear-to-r from-pink-200 to-purple-200 dark:from-pink-500/50 dark:to-purple-500/50 rounded-full opacity-75 blur-xs" />
        <img
          src={member.avatar ?? 'blob'}
          alt={member.name}
          className="relative w-16 h-16 rounded-full border-2 border-white dark:border-gray-700"
        />
      </div>
      <div>
        <h3 className="text-xl font-bold text-pink-600 dark:text-pink-300">{member.name}</h3>
      </div>
    </div>
    <div className="space-y-2 mb-4">
      <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
        <PenTool size={16} className="text-pink-500 dark:text-pink-400" />
        <span className="text-sm">Tools: {member.tools.length}</span>
      </div>
      <div className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
        <Sparkles size={16} className="text-pink-500 dark:text-pink-400" />
        <span className="text-sm">Has System Prompt</span>
      </div>
    </div>
    <div className="flex gap-2">
      <KawaiiButton variant="secondary" className="flex-1" onClick={() => onChat(member.id)}>
        <MessageCircle size={16} />
        Chat
      </KawaiiButton>
      <KawaiiButton
        disabled={member.readOnly}
        variant="secondary"
        className="flex-1"
        onClick={() => onSettings(member.id)}
      >
        <Settings size={16} />
        Settings
      </KawaiiButton>
    </div>
  </div>
);

export default React.memo(MemberCard);
